const TerminosCondiciones = () => {
  return (
    <div className="text-white/80">
      <p className="text-xs text-white/40 mb-6">
        <strong>Última actualización:</strong> 11 de febrero de 2026
      </p>

      <section className="mb-6">
        <h3 className="text-base font-bold text-white mb-3">1. Aceptación de los Términos</h3>
        <p className="text-sm leading-relaxed">
          Al registrarse en TiendasYA, usted acepta estos términos legalmente vinculantes. 
          Si no está de acuerdo, no debe utilizar nuestros servicios.
        </p>
      </section>

      <section className="mb-6">
        <h3 className="text-base font-bold text-white mb-3">2. Descripción del Servicio</h3>
        <p className="text-sm leading-relaxed mb-3">
          TiendasYA es una plataforma SaaS que proporciona herramientas tecnológicas para gestión 
          de comercio electrónico.
        </p>
        <div className="bg-amber-500/10 border border-amber-500/20 rounded-lg p-4">
          <strong className="text-amber-400 text-sm">⚠️ IMPORTANTE:</strong>
          <ul className="mt-2 space-y-1 text-sm">
            <li>• TiendasYA es SOLO un proveedor de software</li>
            <li>• NO procesamos pagos ni somos intermediarios comerciales</li>
            <li>• NO somos responsables de transacciones entre tiendas y clientes</li>
          </ul>
        </div>
      </section>

      <section className="mb-6">
        <h3 className="text-base font-bold text-white mb-3">3. Responsabilidades del Usuario</h3>
        <p className="text-sm mb-2">Usted es el único responsable de:</p>
        <ul className="space-y-1 text-sm ml-4">
          <li>• Todas las transacciones comerciales de su tienda</li>
          <li>• Calidad, legalidad y entrega de productos</li>
          <li>• Gestión de pagos, cobros y devoluciones</li>
          <li>• Cumplimiento de leyes y obligaciones fiscales</li>
          <li>• Servicio al cliente y resolución de disputas</li>
          <li>• Protección de datos de sus clientes</li>
        </ul>
      </section>

      <section className="mb-6">
        <h3 className="text-base font-bold text-white mb-3">4. Limitación de Responsabilidad</h3>
        <div className="bg-red-500/10 border border-red-500/20 rounded-lg p-4">
          <strong className="text-red-400 text-sm">TiendasYA NO es responsable por:</strong>
          <ul className="mt-2 space-y-1 text-sm">
            <li>• Pérdidas económicas o daños derivados del uso de la plataforma</li>
            <li>• Disputas comerciales con sus clientes</li>
            <li>• Fraudes o actividades ilícitas de usuarios</li>
            <li>• Errores en transacciones o pagos</li>
            <li>• Problemas de entrega o productos defectuosos</li>
            <li>• Interrupciones del servicio o fallas técnicas</li>
          </ul>
        </div>
        <p className="text-sm mt-3">
          El servicio se proporciona "TAL CUAL" sin garantías de ningún tipo.
        </p>
      </section>

      <section className="mb-6">
        <h3 className="text-base font-bold text-white mb-3">5. Planes y Pagos</h3>
        <ul className="space-y-1 text-sm ml-4">
          <li>• Los pagos son recurrentes según el plan seleccionado</li>
          <li>• No se realizan reembolsos por servicios prestados</li>
          <li>• La suspensión por falta de pago puede resultar en pérdida de acceso</li>
        </ul>
      </section>

      <section className="mb-6">
        <h3 className="text-base font-bold text-white mb-3">6. Suspensión y Terminación</h3>
        <p className="text-sm mb-2">Podemos suspender su cuenta si:</p>
        <ul className="space-y-1 text-sm ml-4">
          <li>• Incumple estos términos</li>
          <li>• Realiza actividades fraudulentas o ilegales</li>
          <li>• No paga su suscripción</li>
          <li>• Pone en riesgo la seguridad de la plataforma</li>
        </ul>
      </section>

      <section className="mb-6">
        <h3 className="text-base font-bold text-white mb-3">7. Indemnización</h3>
        <p className="text-sm leading-relaxed">
          Usted acepta indemnizar y mantener indemne a TiendasYA de cualquier reclamo, 
          demanda o pérdida que surja de su uso de la plataforma o sus actividades comerciales.
        </p>
      </section>

      <section className="mb-6">
        <h3 className="text-base font-bold text-white mb-3">8. Operaciones Internacionales</h3>
        <p className="text-sm leading-relaxed">
          TiendasYA opera en Latinoamérica. Cada usuario es responsable de cumplir con las 
          leyes locales de su país de operación.
        </p>
      </section>

      <section className="mb-6">
        <h3 className="text-base font-bold text-white mb-3">9. Modificaciones</h3>
        <p className="text-sm leading-relaxed">
          TiendasYA puede modificar estos términos en cualquier momento. 
          Los cambios serán notificados y el uso continuado constituye aceptación.
        </p>
      </section>

      <div className="bg-emerald-500/10 border border-emerald-500/20 rounded-lg p-4 mt-6">
        <strong className="text-emerald-400 text-sm">📋 Al aceptar estos términos, usted declara que:</strong>
        <ul className="mt-2 space-y-1 text-sm">
          <li>• Ha leído y comprendido estos términos en su totalidad</li>
          <li>• Acepta estar legalmente vinculado por estos términos</li>
          <li>• Tiene capacidad legal para celebrar este acuerdo</li>
          <li>• Comprende que TiendasYA es solo un proveedor de software</li>
          <li>• Asume toda responsabilidad por sus operaciones comerciales</li>
        </ul>
      </div>

      <p className="text-xs text-white/40 mt-6 text-center">
        Contacto: tiendasya.app@gmail.com | www.tiendasya.store
      </p>
    </div>
  );
};

export default TerminosCondiciones;
